export const Types = {
    BED_DETAILS: "BED_DETAILS",
    BED_ID_ARRAY: "BED_ID_ARRAY",
    FAVORITE_BED_ID_ARRAY: "FAVORITE_BED_ID_ARRAY",
    HOSPITAL_DATA: "HOSPITAL_DATA",
    WARD_DATA: "WARD_DATA",
    PATIENT_DATA: "PATIENT_DATA",
    DEVICE_VITAL_DATA_ECG: "DEVICE_VITAL_DATA_ECG",
    DEVICE_VITAL_DATA_NIBP: "DEVICE_VITAL_DATA_NIBP",
    DEVICE_VITAL_DATA_TEMP: "DEVICE_VITAL_DATA_TEMP",
    DEVICE_VITAL_DATA_SPO2: "DEVICE_VITAL_DATA_SPO2",
    MONITOR_HEARTBEAT_DATA: "MONITOR_HEARTBEAT_DATA",
    DEVICE_ECG_WAVEFORM_DATA: "DEVICE_ECG_WAVEFORM_DATA",
    DEVICE_RESP_WAVEFORM_DATA: "DEVICE_RESP_WAVEFORM_DATA",
    DEVICE_PLETH_WAVEFORM_DATA: "DEVICE_PLETH_WAVEFORM_DATA",
    NOCCARC_PM_ALARM_DATA: "NOCCARC_PM_ALARM_DATA",
    VENTILATOR_ALARM_DATA: "VENTILATOR_ALARM_DATA",
    NOTIFICATION_DATA: "NOTIFICATION_DATA",
    CONFIG_VIEW_TYPE: "CONFIG_VIEW_TYPE",
    CONFIG_FILTER_TYPE: "CONFIG_FILTER_TYPE",
    CONFIG_MODAL: "CONFIG_MODAL",
    CONFIG_BED_DETAILS: "CONFIG_BED_DETAILS",
    CONFIG_ADD_COLUMN: "CONFIG_ADD_COLUMN",
    CONFIG_REMOVE_COLUMN: "CONFIG_REMOVE_COLUMN",
    CLEAR_ALARM: "CLEAR_ALARM",
    PATIENT_DISCHARGE: "PATIENT_DISCHARGE",
    CLEAR_STORE: "CLEAR_STORE",
    SELECTED_BED: 'SELECTED_BED',
    SELECTED_WARD: 'SELECTED_WARD',
    BED_DATA: 'BED_DATA',
    CLEAR_BED_ALARM: 'CLEAR_BED_ALARM',
    VENTILATOR_VITAL_DATA: "VENTILATOR_VITAL_DATA",
    SIDEBAR_ACTIVE_ICON: "SIDEBAR_ACTIVE_ICON",
    ACTIVE_DEVICE: "ACTIVE_DEVICE",
    USER_VIEW: "USER_VIEW",
    VENTILATOR_MODES_DATA: 'VENTILATOR_MODES_DATA',
    VENTILATOR_PATIENT_MODE_ALARM_PROFILE_DATA: 'VENTILATOR_PATIENT_MODE_ALARM_PROFILE_DATA',
    VENTILATOR_WAVEFORM_DATA: "VENTILATOR_WAVEFORM_DATA",
    VENTILATOR_HEARTBEAT_DATA: "VENTILATOR_HEARTBEAT_DATA",
    VENTILATOR_STANDBY_DATA: "VENTILATOR_STANDBY_DATA",
    VENTILATOR_ADDITIONAL_FEATURES_DATA: "VENTILATOR_ADDITIONAL_FEATURES_DATA",
    VENTILATOR_MODULE_CONNECTION_STATUS_DATA: "VENTILATOR_MODULE_CONNECTION_STATUS_DATA",
    VENTILATOR_PATIENT_HISTORY_TIME_DATA: "VENTILATOR_PATIENT_HISTORY_TIME_DATA",
    VENTILATOR_PATIENT_HISTORY_GRAPH_API_DATA: "VENTILATOR_PATIENT_HISTORY_GRAPH_API_DATA",
    VENTILATOR_PATIENT_HISTORY_CURSOR_DATA: "VENTILATOR_PATIENT_HISTORY_CURSOR_DATA",
    VENTILATOR_PATIENT_HISTORY_CURRENT_CURSOR_TIME: "VENTILATOR_PATIENT_HISTORY_CURRENT_CURSOR_TIME",
    VENTILATOR_PATIENT_HISTORY_PATIENT_MODE_AP_DATA: "VENTILATOR_PATIENT_HISTORY_PATIENT_MODE_AP_DATA",
    VENTILATOR_PATIENT_HISTORY_EVENT_HISTORY_DATA: "VENTILATOR_PATIENT_HISTORY_EVENT_HISTORY_DATA",
    VENTILATOR_PATIENT_HISTORY_LIVE_ALARM_HISTORY_DATA: "VENTILATOR_PATIENT_HISTORY_LIVE_ALARM_HISTORY_DATA",
    VENTILATOR_PATIENT_HISTORY_ADDITIONAL_FEATURES_DATA: "VENTILATOR_PATIENT_HISTORY_ADDITIONAL_FEATURES_DATA",

};